import { previewDataInterface as _previewDataInterface } from "@/api/systemData/dataInterface";
var actions = {
  previewDataInterface: function previewDataInterface(commit, data) {
    return new Promise(function (resolve, reject) {
      _previewDataInterface.then((function (res) {
        resolve(res);
      }, function (err) {
        reject(err);
      }));
    });
  }
};
export default {
  namespaced: true,
  actions: actions
};